import React,{ FormEvent, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { API_URL } from "../utils/utility";
import axios from 'axios'
import { data } from "jquery";
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";
function NIJ() {
    const [country, setCountry] = useState([])
    const API = 'https://www.indianarmour.com/indianarmourcms/APIs/Contactus/country.php';
    const fetchPost = () => {
      fetch(API)
        .then((res) => res.json())
        .then((res) => {
          console.log(res)
          setCountry(res)
        })
    }
    useEffect(() => {
      fetchPost()
    }, [])
  
  
  
  
    const navigate = useNavigate();
    const [info, setInfo] = useState({
        type: "message",
        body: "",
      });
  
    const SaveData = async (END_POINT , body ) => {
      console.log(END_POINT, body);
      var response = await axios.post( END_POINT, body);
      console.log(response)
      return { data: response.data, message: response.message, status: response.status || response.statusCode, errors: response.errors };
    };
  
    const { register, handleSubmit, formState: { errors }} = useForm();
    const onSubmit = async(values) => {
      
      console.log(values)
     
      try {
        let apiRes = null;
      
    
    
          apiRes = await SaveData(`${API_URL}/APIs/Contactus/index.php`, {
            ...values 
             
          });
       console.log(apiRes.status)
        if (apiRes.status == 200 && apiRes.data[0].Status == "True") {
          setInfo({ type: "message", body: "Form Submitted Successfully!" });
        //  setsubmitdisable(true)
         
        navigate(`/Thankyou`);
        } else if(apiRes.data[0].Status == "False") {
          
          setInfo({ type: "error", body: "Something went wrong. Please try again!" });
          // throw new Error(apiRes.errors);
        }
      } catch (err) {
        setInfo({ type: "error", body: err.message });
      } 
      // finally {
      //   setApiStatus({ ...apiStatus, inProgress: false });
      // }
    
    };
    return (
        <>
    <Helmet>
        <title>Understanding NIJ Ballistic Standards & Protection Levels | Indian Armour</title>
        <meta name="description" content="Understand NIJ body armour standards and ballistic protection levels from IIA to IV. Indian Armour explains NIJ certification, testing protocols, and how protective equipment meets global safety requirements for military and tactical missions." />
        <link rel="canonical" href="https://www.indianarmour.com/nij-standards" />
      </Helmet>
            <section className="inner-banner d-flex align-items-center justify-content-center" style={{ backgroundImage: 'url("/images/nij/new/banner.webp")' }}>
                <div className="inner-banner-content1">
                    <div className="container">
                        <h1 className=" fw-bolder">NIJ Standards</h1>
                        {/* <strong>Custom Protection, Tailored for Every Mission</strong> */}
                    </div>
                </div>
            </section>

            <section className="breadcrumb-inner pt-3  pb-5">
                <div className="container">
                    <nav >
                        <ol className="breadcrumb mb-0 justify-content-start">
                            <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">NIJ Standards</li>
                        </ol>
                    </nav>
                </div>
            </section>


            <section className='page-content pb-5'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                          <p>At Indian Armour, our commitment to safety is grounded in internationally
recognised ballistic performance standards. The National Institute of Justice (NIJ)
standards are globally accepted benchmarks for evaluating ballistic resistance and
are widely referenced by military forces, law enforcement agencies, and security
organisations worldwide. NIJ standards define how armour systems must perform
when exposed to handgun, rifle, and armour-piercing threats under controlled and
repeatable test conditions.
</p>
                        </div>
                    </div>
                </div>
            </section>

           
  <section className="bg-pink py-70 benefits-nij-solution nij-sec2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4"><div className="vertical-integration">
                          <img src="/images/nij/new/reel-2.png" alt="" className='img-fluid' /></div></div>
                        <div className="col-lg-8">
                             
                            <p>Ballistic protection is a science — and NIJ standards make that
science measurable, repeatable, and globally comparable.
Each armour model undergoes a series of stringent tests
including shot placement, environmental conditioning,
impact resistance, durability assessment and multi-hit ballistic
performance. These tests confirm whether the armour meets
the precise levels of protection required for field operations. At
Indian Armour, we integrate NIJ compliance not only as a
certification target, but as a core philosophy across our
materials, design engineering, manufacturing, and final
product validation.
</p>
                        </div>
                    </div>
                </div>
            </section>

             <section className="py-70 benefits-nij-solution">
               <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2><strong>Why NIJ Standards Matter
 </strong></h2>
                        <p>NIJ standards provide a transparent and internationally accepted framework for
understanding ballistic performance. They allow users and procurement agencies to
clearly identify the ammunition types and threat levels against which an armour
system has been tested, as well as the consistency and reliability of that performance.</p><p>
Under NIJ protocols, armour is evaluated not only for ballistic resistance, but also for
its ability to perform after exposure to adverse environmental conditions such as heat,
cold, humidity, and mechanical stress. This ensures that protection levels remain
consistent across production batches and during prolonged field use.</p><p>
For government agencies, tactical units, and private security operators, NIJ
compliance offers confidence that the armour will perform when required most.
Indian Armour follows these standards through testing conducted at accredited
ballistic laboratories, supplemented by rigorous in-house quality assurance and
validation procedures.
                        </p>

                      
                    </div>
                </div>
               </div>
            </section> 

   <section className="bg-pink  py-70 benefits-nij-solution">
               <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2><strong>NIJ 0101.07</strong></h2>
                       <p>NIJ 0101.07 is the latest and current NIJ ballistic resistance standard and has formally superseded NIJ
0101.06. While NIJ 0101.06 remains relevant for legacy classifications and comparison, Indian Armour's
engineering, testing roadmap, and future product validation are primarily aligned with NIJ 0101.07
requirements. By designing and evaluating our armour systems in line with both NIJ 0101.06 (reference) and
NIJ 0101.07 (current standard), we ensure that our solutions remain technically robust, future-ready, and
suitable for real-world operational deployment.</p>

                      
                    </div>
                </div>
               </div>
            </section> 


               <section className=" py-70 benefits-nij-solution">
               <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2><strong>NIJ Protection Levels Explained
 </strong></h2>
                       <p>NIJ 0101.07 introduces a revised and more threat-representative classification system
compared to NIJ 0101.06. Protection levels are categorised into Handgun (HG) and
Rifle (RF) classes, with clearly defined test ammunition and reference velocities.
Indian Armour aligns its product development and validation primarily with NIJ
0101.07, while maintaining NIJ 0101.06 equivalence for legacy reference.
</p>

                      
                    </div>
                </div>
               </div>
            </section> 


 <section className='bg-pink  py-70   nij-table    table-block pb-50'>
  <div className='container'>
     <div className='row'>
        <div className='col-lg-12'>
          <h2><strong>Handgun Protection Levels (NIJ 0101.07)</strong></h2>
          <div className='table-responsive'>
            <table className='table table-bordered table-striped table-bordar-white'>
          
    <thead>
      <tr>
        
        <th>NIJ Level</th>
        <th>Test Threat</th>
        <th>Ammunition Identifier</th>
        <th>Reference Velocity</th>
         
      </tr>
    </thead>
    <tbody>
      <tr>
     <td>HG1</td>
     <td>
      <ul>
        <li>9x19 mm FMJ RN, 124 gr</li>
        <li>.357 Magnum JSP, 158 gr</li>
        </ul>
        </td>
     <td><ul>
        <li> Remington #23558</li>
        <li>Remington #22847
 </li>
        </ul></td>
      <td><ul>
        <li>1305 ft/s (398 m/s) </li>
        <li> 1430 ft/s (436 m/s)
</li>
        </ul></td>
        
      </tr>

    <tr>
     <td>HG2</td>
     <td>
      <ul>
        <li>9×19 mm FMJ RN, 124 gr</li>
        <li>.44 Magnum JHP, 240 gr</li>
        </ul>
        </td>
     <td><ul>
        <li>Remington #23558</li>
        <li>Speer OEM #74453, #4453 or #4736
 </li>
        </ul></td>
      <td><ul>
        <li>1470 ft/s (448 m/s) </li>
        <li> 1430 ft/s (436 m/s)
</li>
        </ul></td>
        
      </tr>
      
     
    </tbody>
  </table>
         
          </div>
        </div>
      </div>    
  </div>
 </section>



 <section className='py-70  nij-table table-block pb-50'>
  <div className='container'>
     <div className='row'>
        <div className='col-lg-12'>
          <h2><strong>Rifle Protection Levels (NIJ 0101.07)
</strong></h2>
          <div className='table-responsive'>
            <table className='table table-bordered table-striped'>
          
    <thead>
      <tr>
        
        <th>NIJ Level</th>
        <th>Test Threat</th>
        <th>Ammunition Identifier</th>
        <th>Reference Velocity</th>
         
      </tr>


      
    </thead>
    <tbody>
      <tr>
     <td>RF1</td>
     <td>
      <ul>
        <li>7.62x51 mm M80 Ball NATO FMJ, 147 gr</li>
        <li>7.62x39 mm MSC Ball, Type 56</li>
         <li>5.56x45 mm M193, 56 gr
</li>
        </ul>
        </td>
     <td><ul>
        <li> US military / NATO-spec</li>
        <li>Factory 31
 </li>
 <li>US military / NATO-spec</li>
        </ul></td>
      <td><ul>
        <li>2780 ft/s (847 m/s)</li>
        <li> 2400 ft/s (732 m/s)
</li>
<li>3250 ft/s (990 m/s)</li>
        </ul></td>
        
      </tr>

   
         <tr>
     <td>RF2</td>
     <td>
      <ul>
        <li>7.62x51 mm M80 Ball NATO FMJ, 147 gr</li>
        <li>7.62x39 mm MSC Ball, Type 56</li>
         <li>5.56x45 mm M193, 56 gr
</li>
<li>5.56x45 mm M855, 62 gr
</li>
        </ul>
        </td>
     <td><ul>
        <li> US military / NATO-spec</li>
        <li>Factory 31
 </li>
 <li>US military / NATO-spec</li>
 <li>US military / NATO-spec</li>
        </ul></td>
      <td><ul>
        <li>2780 ft/s (847 m/s)</li>
        <li> 2400 ft/s (732 m/s)
</li>
<li>3250 ft/s (990 m/s)</li>
<li>3115 ft/s (950 m/s)</li>
        </ul></td>
        
      </tr>


         <tr>
     <td>RF3</td>
     <td>
      <ul>
        <li>.30-06 M2 AP, 165.7 gr </li>
        
        </ul>
        </td>
     <td><ul>
        <li> US military / NATO-spec </li>
         
        </ul></td>
      <td><ul>
        <li>2880 ft/s (878 m/s)
</li>
         
        </ul></td>
        
      </tr>
     
    </tbody>
  </table>
         
          </div>
        </div>
      </div>    
  </div>
 </section>







 <section className="bespoke-process bg-pink  py-70">
                <div className="bespoke-heading"><div className="container"><h2><strong>NIJ Testing & Evaluation Process
</strong></h2>
 

</div></div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <p>To ensure the reliability of armour products, NIJ mandates a rigorous evaluation
procedure that Indian Armour follows completely. Every certified product must pass:</p>
                               <ul className="bespoke-process-list font-20">
                                <li> <span><strong>Ballistic Testing
 </strong>This includes multi-shot impact testing at specified velocities and angles. Armour is
shot using exact ammunition types and carefully measured distances. The objective is
to prevent penetration and minimise back-face deformation, ensuring safe energy
absorption.</span>
<span className="mobile-nij-img">
<img width="60px" height="60px" src="/images/nij/new/icons/2.svg" alt="" />
<img width="100px" height="60px" src="/images/nij/new/icons/1.svg" alt="" />
</span>

</li>

                                <li><span><strong>Environmental Conditioning  </strong> - Before ballistic testing, armour is subjected to cycles of heat, cold, humidity, and
mechanical stress. This simulates real-world conditions such as desert heat, freezing
climates, moisture exposure, and rough handling.</span> <img width="60px" height="60px" src="/images/nij/new/icons/3.svg" alt="" /></li>   

                                <li><span><strong>Durability & Impact Testing  </strong> Armour is dropped from height, compressed, flexed and impacted to verify that
structural integrity is maintained even after rough usage.
</span> <img width="60px" height="60px" src="/images/nij/new/icons/4.svg" alt="" /></li>



 <li><span><strong>Back-Face Signature Measurement  </strong> The deformation created on the backside of the armour is precisely measured to ensure
safe trauma limits and prevent fatal injuries due to blunt impact.
</span> <img width="60px" height="60px" src="/images/nij/new/icons/5.svg" alt="" /></li>



 <li><span><strong>Ongoing Compliance & Batch Testing </strong> NIJ-compliant armour must be continuously evaluated to ensure that every production
lot meets the required performance standards.
</span> <img width="60px" height="60px" src="/images/nij/new/icons/6.svg" alt="" /></li>



 
                               </ul>

 <p>At Indian Armour, we exceed these requirements by integrating additional in-house QC
procedures, X-ray scanning of ceramic plates, adhesive bond integrity checks and
repeated ballistic trials.</p>
                        </div>
                    </div>
                </div>
            </section>


   <section className="py-70 benefits-nij-solution">
               <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2><strong>Indian Armour NIJ-Compliant Product Range
</strong></h2>
                       <p>With complete in-house manufacturing capability, Indian Armour delivers a wide
portfolio of NIJ-rated products:</p>

                      
                    </div>
                </div>
               </div>
            </section> 





 <section className="bg-pink  py-70 benefits-nij-solution bespoke-process   ">
                <div className="container">
                    <div className="row col-reverse">
                        
                        <div className="col-lg-6">
                            <h3><strong>Soft Armour Solutions
</strong> </h3>
                            <ul className="bespoke-process-list">
                              <li>Concealable vests (HGII/ Level IIIA)</li>
                              <li>Tactical overt vests (HGII/ Level IIIA)</li>
                              <li>Multi-threat protection panels</li>
                              <li>Female body armour systems
</li>
                            </ul>
                        </div>
                        <div className="col-lg-6"><div className="vertical-integration"><img src="/images/nij/new/2.png" alt="" className='img-fluid' /></div></div>
                    </div>
                </div>
            </section>

  

            <section className="py-70 benefits-nij-solution  bespoke-process  ">
                <div className="container">
                    <div className="row  ">
                        <div className="col-lg-6"><div className="vertical-integration"><img src="/images/nij/new/3.png" alt="" className='img-fluid' /></div></div>
                        <div className="col-lg-6">
                            <h3><strong>Hard Armour Plates
</strong> </h3>
                            <ul className="bespoke-process-list">
                              <li>Single-curve and multi-curve plates
</li>
                            <li>Ceramic + UHMWPE composite plates</li>
                            <li>Silicon Carbide and Alumina plates</li>
                            <li>Lightweight pure UHMWPE plates</li>
                            <li>NIJ Level III (RF1) , Level III+ (RF2) & Level IV (RF3)
protection</li>
                            </ul>
                            
                        </div>
                    </div>
                </div>
            </section>


 <section className="bg-pink  py-70 benefits-nij-solution  bespoke-process  ">
                <div className="container">
                    <div className="row  col-reverse">
                        
                        <div className="col-lg-6">
                            <h3><strong>BALLISTIC HELMETS
</strong> </h3>
                            <ul className="bespoke-process-list">
                              <li>ACH, MICH, PASGT & FAST models</li>
                              <li>Boltless technology helmets</li>
                              <li>NIJ Level IIIA / HGII protection</li>
                              <li>High-cut, mid-cut and full-cut designs</li>
                            </ul>
                        </div>
                        <div className="col-lg-6"><div className="vertical-integration"><img src="/images/nij/new/4.png" alt="" className='img-fluid' /></div></div>
                    </div>
                </div>
            </section>


  <section className="py-70 benefits-nij-solution  bespoke-process  ">
                <div className="container">
                    <div className="row  ">
                        <div className="col-lg-6"><div className="vertical-integration"><img src="/images/nij/new/5.png" alt="" className='img-fluid' /></div></div>
                        <div className="col-lg-6">
                            <h3><strong>BALLISTIC SHIELDS
</strong> </h3>
                            <ul className="bespoke-process-list">
                              <li>Ultra-lightweight NIJ IIIA/ HGII shields
</li>
                            <li>Tactical shields with viewport</li>
                            <li>NIJ III (RF1), Level III+(RF2) and NIJ IV (RF3) rifle-rated shields</li>
                            
                            </ul>
                            
                        </div>
                    </div>
                </div>
            </section>


 <section className="bg-pink  py-70 bespoke-process  benefits-nij-solution">
                <div className="container">
                    <div className="row  col-reverse">
                        
                        <div className="col-lg-6">
                            <h3><strong>ARMOURED PANELS
</strong> </h3>
                            <ul className="bespoke-process-list">
                              <li>Vehicle armour kits</li>
                              <li>Maritime armour panels
</li>
                              <li>Building & safe-room protection</li>
                              
                            </ul>
                        </div>
                        <div className="col-lg-6"><div className="vertical-integration"><img src="/images/nij/new/6.png" alt="" className='img-fluid' /></div></div>
                    </div>
                </div>
            </section>















            
  {/* <section className="py-70">
                <div className="container">
                    <div className="row">
                        
                        <div className="col-lg-12">
                            <p>Every product is tested and validated to ensure dependable protection under the latest
NIJ standards</p>
                             
                            
                        </div>
                    </div>
                </div>
            </section> */}

  <section className="py-70 benefits-nij-solution">
                <div className="container">
                    <p>Every product is tested and validated to ensure dependable protection under the latest
NIJ standards</p>
                    <div className="row">
                        <div className="col-lg-4"><div className="vertical-integration"><img src="/images/nij/new/7.png" alt="" className='img-fluid' /></div></div>
                        <div className="col-lg-8">
                            <h3><strong>Our Commitment to NIJ Compliance
</strong> </h3>
                            <p>NIJ 0101.07 has formally superseded NIJ 0101.06 as the
current ballistic resistance standard, and all future NIJ
compliance and official product listings are governed by NIJ
0101.07. Indian Armour has aligned its engineering, testing
roadmap, and product validation strategy accordingly, while
maintaining technical equivalence with NIJ 0101.06 for
legacy platforms.
</p>
<p>Indian Armour is among the first companies to have been
allotted official NIJ test identification numbers for
evaluation under the latest NIJ 0101.07 standard. Our
product samples are currently under evaluation at NIJapproved ballistic laboratories. At present, no manufacturer
worldwide holds listed NIJ 0101.07 compliant products, as
the National Institute of Justice has not yet released the
official Compliant Products List (CPL) for NIJ 0101.07 testing.
</p>
                            
                        </div>
                    </div>
                </div>
            </section>

  <section className="bg-pink  py-70">
                <div className="container">
                    <div className="row">
                        
                        <div className="col-lg-12">
                            <p>This early participation reflects Indian Armour’s proactive commitment to nextgeneration standards, technical transparency, and long-term compliance. Indian Armour
operates with complete vertical integration, from raw material processing and fabric
manufacturing to ceramic strike-face production and final system assembly. This enables
strict control over quality, consistency, and testing accuracy. Through continuous research
and development, material innovation, and precision engineering, we deliver NIJcompliant ballistic protection systems that perform reliably in critical operational
scenarios.</p>
                             
                            
                        </div>
                    </div>
                </div>
            </section>







 <section className="  py-70 benefits-nij-solution">
                <div className="container">
                    <div className="row">
                        
                        <div className="col-lg-6">
                            <h3><strong>Need NIJ-Compliant Ballistic Protection?
</strong> </h3>
                            <p>We support custom specifications, bulk orders
and agency-level procurement for all NIJ-rated
products. Our team can help you select the
correct protection level for operational
requirements.
</p>
                        </div>
                        <div className="col-lg-6"><div className="vertical-integration"><img src="/images/nij/new/8.png" alt="" className='img-fluid' /></div></div>
                    </div>
                </div>
            </section>











       


            {/* <section className="py-70  bg-black">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-white">
                            <h2 className='font-42 d-flex align-items-center justify-content-center mb-5'>Try Our Bespoke Solutions Now! <img src="//images/timely-and-reliable-delivery.png" alt="" class="ms-3 clock-img" /></h2>
                            <p className="text-white">Deviating from the one-size-fits-all approach, Indian Armour's bespoke solutions provide the customization necessary to address the unique challenges you might face. Our commitment to innovation, quality, and customer satisfaction makes us the ideal destination for tailored protection solutions. 
                            </p>
                            <p className="text-white">
                            Explore the possibilities with Indian Armour's bespoke solutions today and experience the difference that custom-designed protection gear can make.

                            </p>
                        </div>
                    </div>
                </div>
            </section> */}

            <section className="py-70 vi-contact" style={{ backgroundImage: 'url("/images/vertical-integration-contact.jpg")' }}>
        <div className="container">
          <h2 className="font-42"><strong>Contact Us Now</strong></h2>
          <div className="row">
            <div className="col-lg-6">
              <img src="/images/vi-contact-img.png" alt="" className="img-fluid"/>
            </div>
            <div className="col-lg-6">
              <div className="contact-us-right">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Full Name *"
                    onInput={(e) => e.target.value = e.target.value.replace(/[^\w\s]/gi, "")}
            
                    {...register("name", { required: true })}
                  />
                  {errors.name && <span className='error'>Full Name is required</span>}
                </div>
                <div className="mb-3">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter Email Address *"
                    {...register("email", { required: true })}
                  />
                   {errors.email && <span className='error'>Email Address is required</span>}
                </div>
                <div className=" mb-3 position-relative mobile-number">
                  {/* <span className="p-number">+91</span> */}
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Mobile Number *"
                    onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                    {...register("mobile", {  required: false})}
                  />
                  {errors.mobile && <span className='error'>Phone Number required</span>}
                </div>

                <div className=" mb-3 position-relative country">
                  
                   <select className="form-control" {...register("country", {  required: true})}>
                   <option value="">Select Country</option>
                   {country.map((item) => (
                        
                        <option value={item.name}>{item.name}</option>
                        
                        ))}
                   
                   </select>
                 
                   {errors.country && <span className='error'>Country required</span>}
                </div>
                <div className="mb-3">
                  <textarea
                    className="form-control"
                    placeholder="Message"
                    defaultValue={""}
                    {...register("message", { required: true })}
                  />
                   {errors.message && <span className='error'>Message is required</span>}
                </div>
                <div className="input-group justify-content-center mt-5">
                  <button className="btn know-more-btn submit">
                    Submit
                    <span className="input-group-text">
                      <img src="/images/arrow.svg" />
                    </span>
                  </button>
                </div>
              </form>
              </div>
            </div>
          </div>
        </div>
      </section>
        </>
    )
}

export default NIJ